module.exports = __webpack_public_path__ + "static/img/appoint_banner_iphone.3e0a16c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appoint_banner_iphone.png
// module id = wjsM
// module chunks = 1